export default "assets/success-6cb4e499.svg";